var SCM = SCM || {};

SCM.Dropdowns = (function ($) {

    var triggerActiveClass = 'active';
    var dropdownExpandedClass = 'expanded';
    var dropdownOpenClass = 'open';

    var $jsDropdownTrigger;
    var $jsDropdown;
    var $dataDropdownTrigger;
    var $dataDropdown;

    var jsDropdownTrigger;
    var dataDropdownTrigger;

    var lastInteractionWasKeyboard = false;

    return {
        init: _init
    };

    function _init() {
        $jsDropdownTrigger = $('.js-theme-dropdown-trigger');
        $jsDropdown = $('.js-theme-dropdown');
        $dataDropdownTrigger = $('[data-theme-dropdown-trigger]');
        $dataDropdown = $('[data-theme-dropdown]');

        jsDropdownTrigger = '.js-theme-dropdown-trigger';
        dataDropdownTrigger = '[data-theme-dropdown-trigger]';

        $dataToolboxDropdownTrigger = $('.js-toolbar-dropdown');
        $dataToolboxDropdown = $('.js-articledropdown');

        trackInteractionType();
        jsDropdownTriggerClick();
        dataDropdownTriggerClick();
        closeDataDropdownOnFocusOut();
        closeJsDropdownOnFocusOut();

        $(document.body).on('click', function (e) {
            closeAllDropdowns(e);
        });

        $(document).on('keydown', function (e) {
            if (e.key === "Escape" || e.keyCode === 27) {
                closeAllDropdowns(e);
            }
        });
    }

    // Focusout-close serves keyboard users; for touch/mouse, focus can move without intent (SCMP-38241).
    function trackInteractionType() {
        document.addEventListener('keydown', function () {
            lastInteractionWasKeyboard = true;
        }, true);
        document.addEventListener('pointerdown', function () {
            lastInteractionWasKeyboard = false;
        }, true);
    }

    function jsDropdownTriggerClick() {
        $(document.body).on('click', jsDropdownTrigger, function (e) {
            var $dropdownTrigger = $(e.currentTarget);
            var $dropdown = $dropdownTrigger.next('.js-theme-dropdown');
            e.stopPropagation();
            _closeNonParentDropdowns($dropdownTrigger, $dropdown);
            $dropdownTrigger.toggleClass(triggerActiveClass);
            $dropdown.toggleClass(dropdownExpandedClass);
            SCM.DropdownContainment.keepInViewport($dropdown.filter('.' + dropdownExpandedClass));
            if ($dropdownTrigger.attr('aria-expanded') == 'true') {
                $dropdownTrigger.attr('aria-expanded', 'false');
            } else {
                $dropdownTrigger.attr('aria-expanded', 'true');
            }
        });
    }

    function dataDropdownTriggerClick() {
        $(document.body).on('click', dataDropdownTrigger, function (e) {
            var $dropdownTrigger = $(e.currentTarget);
            var dropdownTriggerDataVal = $dropdownTrigger.data('themeDropdownTrigger');
            var $dropdown = $('[data-theme-dropdown="' + dropdownTriggerDataVal + '"');
            e.stopPropagation();
            _closeNonParentDropdowns($dropdownTrigger, $dropdown);
            $dropdownTrigger.toggleClass(triggerActiveClass);
            $dropdown.toggleClass(dropdownExpandedClass);
            SCM.DropdownContainment.keepInViewport($dropdown.filter('.' + dropdownExpandedClass));
            if ($dropdownTrigger.attr('aria-expanded') === 'true') {
                $dropdownTrigger.attr('aria-expanded', 'false');
            } else {
                $dropdownTrigger.attr('aria-expanded', 'true');
            }
        });
    }

    function closeJsDropdownOnFocusOut() {
        $(document.body).on('focusout', '.js-theme-dropdown.expanded, .js-articledropdown.open', function (e) {
            var $relatedTarget = $(e.relatedTarget);
            var $currentTarget = $(e.currentTarget);
            e.stopPropagation();
            if (!lastInteractionWasKeyboard) {
                return;
            }
            setTimeout(function () {
                if (!$relatedTarget.parents('.js-theme-dropdown.expanded, .js-articledropdown.open').length) {
                    $jsDropdownTrigger.removeClass(triggerActiveClass);
                    $jsDropdownTrigger.attr('aria-expanded', 'false');
                    $currentTarget.removeClass(dropdownExpandedClass);
                    $dataToolboxDropdownTrigger.attr('aria-expanded', 'false');
                    $dataToolboxDropdown.removeClass(dropdownOpenClass);
                }
            }, 100);
        });
    }

    function closeDataDropdownOnFocusOut() {
        $(document.body).on('focusout', '[data-theme-dropdown].expanded, [data-theme-dropdown].open', function (e) {
            var childIsInFocus = $(e.relatedTarget).parents('[data-theme-dropdown].expanded, [data-theme-dropdown].open').length;
            var nullFocus = e.relatedTarget == null;
            e.stopPropagation();
            if (childIsInFocus || nullFocus || !lastInteractionWasKeyboard) {
                return;
            } else {
                $dataDropdownTrigger.removeClass(triggerActiveClass);
                $dataDropdownTrigger.attr('aria-expanded', 'false');
                $(e.currentTarget).removeClass(dropdownExpandedClass);
                $dataToolboxDropdownTrigger.attr('aria-expanded', 'false');
                $dataToolboxDropdown.removeClass(dropdownOpenClass);
            }
        });
    }

    function closeAllDropdowns(e) {
        if (!$(e.target).closest('.js-dropdown.expanded, .js-theme-dropdown.expanded, js-articledropdown.open, [data-theme-dropdown].expanded').length) {
            $jsDropdownTrigger.removeClass(triggerActiveClass);
            $jsDropdownTrigger.attr('aria-expanded', 'false');
            $jsDropdown.removeClass(dropdownExpandedClass);
            $dataDropdownTrigger.removeClass(triggerActiveClass);
            $dataDropdownTrigger.attr('aria-expanded', 'false');
            $dataDropdown.removeClass(dropdownExpandedClass);
            $dataToolboxDropdownTrigger.attr('aria-expanded', 'false');
            $dataToolboxDropdown.removeClass(dropdownOpenClass);
        }
    }

    function _closeNonParentDropdowns($triggerToKeepActive, $dropdownToKeepActive) {
        if (!$triggerToKeepActive.closest('[data-theme-dropdown].expanded, .js-theme-dropdown.expanded').length) {
            $jsDropdownTrigger.not($triggerToKeepActive).removeClass(triggerActiveClass).attr('aria-expanded', 'false');
            $jsDropdown.not($dropdownToKeepActive).removeClass(dropdownExpandedClass);
            $dataDropdownTrigger.not($triggerToKeepActive).removeClass(triggerActiveClass).attr('aria-expanded', 'false');
            $dataDropdown.not($dropdownToKeepActive).removeClass(dropdownExpandedClass);
        }
    }

})(jQuery);
